import { Skeleton, Text } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { useContractorDetailQuery } from "@src/__generated__/graphql";
import { Card, LoadingOverlay } from "@src/components/ui-kit";
import { onError } from "@src/utils/apollo";
import { withCan } from "@src/utils/components/permissions";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { Detail } from "./components";
import { Contractor } from "./models";

interface ContractorDetailProps {
  id: string;
}

const ContractorDetail = ({ id }: ContractorDetailProps) => {
  const [contractor, setContractor] = useState<Contractor | undefined | null>();

  const { loading } = useContractorDetailQuery({
    variables: { id },
    skip: !id,
    notifyOnNetworkStatusChange: true,
    onCompleted({ contractor }) {
      if (!contractor) {
        setContractor(null);
        return;
      }
      setContractor(new Contractor(contractor));
    },
    ...onError(),
  });

  return (
    <Card>
      <LoadingOverlay position="absolute" isLoading={loading}>
        {contractor === undefined ? (
          <Skeleton minH="40dvh" />
        ) : contractor === null ? (
          <Text p="4" fontSize="lg" fontWeight="bold" textAlign="center">
            <Trans>Something went wrong, please try again later</Trans>
          </Text>
        ) : (
          <Detail contractor={contractor} setContractor={setContractor} />
        )}
      </LoadingOverlay>
    </Card>
  );
};

export default withCan({ do: "contractor_read" }, observer(ContractorDetail));
